import React from "react";
import { Button, Stack, Typography } from "@mui/material";

type PagingControlsProps = {
    enabled: boolean;
    start: number;
    total: number;
    pageSize: number;
    maxStart: number;
    onPrev: () => void;
    onNext: () => void;
};

export const PagingControls: React.FC<PagingControlsProps> = ({
    enabled,
    start,
    total,
    pageSize,
    maxStart,
    onPrev,
    onNext,
}) => {
    if (!enabled) return null;

    const label = total === 0
        ? "0 von 0"
        : `${start + 1}-${Math.min(total, start + pageSize)} von ${total}`;

    return (
        <Stack direction="row" spacing={1} alignItems="center">
            <Button
                variant="outlined"
                size="small"
                onClick={onPrev}
                disabled={start === 0}
            >
                Zurück
            </Button>
            <Typography variant="caption" color="text.secondary">
                {label}
            </Typography>
            <Button
                variant="outlined"
                size="small"
                onClick={onNext}
                disabled={start >= maxStart}
            >
                Vor
            </Button>
        </Stack>
    );
};
